import React, {FC} from "react";
import cls from "../builder.module.scss";
interface IProps {
    item: {
        tag: string;
        headingText: string;
        customClassNames: string;
        convertedSettings: {
            animationAos: { "data-aos": any },
            styles: any;
            parentStyles: any
        },
        headingSettings: {
            fontSize: number
        },
        hoverAnimation: string
    }
}

const Heading: FC<IProps> = (
    {
        item: {
            tag,
            headingText = "",
            customClassNames,
            convertedSettings: {
                animationAos: {"data-aos": dataAos = null} = {},
                styles = {},
                parentStyles = {}
            } = {},
            headingSettings: {
                fontSize
            } = {},
            hoverAnimation
        }
    }
) => {
    return <div data-aos={dataAos} style={parentStyles}>
        <div
            style={styles}
            className={`${customClassNames} ${cls[hoverAnimation ?? "none"]}`}
            dangerouslySetInnerHTML={{ __html: `<${tag} style="font-size: ${fontSize}px;">${headingText}</${tag}>` }}/>
    </div>
}

export default Heading;
